import React from "react";
import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";
import { useRouter } from "next/router";
import styles from "./email-form-node.module.scss";

function DeliveryResponse() {
  const router = useRouter();
  return (
    <>
      <div>
        <Message
          type="information"
          title="Did you know..."
          body="You can monitor the progress of most deliveries through our online tracker"
          buttonText="Track your order online"
          buttonProps={{
            onClick: () => {
              router.push("https://account.johnlewis.com/track-order");
            },
          }}
          whiteBackground
          wideTab
        />
      </div>
      <div className={styles.dividerWithText}>OR</div>
    </>
  );
}

export default DeliveryResponse;
